

import { atom , useRecoilValue, useSetRecoilState, useResetRecoilState} from "recoil";


const moduleListAtom = atom({key:'moduleListAtom', default:{module_list:[]
}});


const moduleEditAtom = atom({key:'moduleEditAtom', default:{}});





export  const SetModuleList = () => useSetRecoilState(moduleListAtom);
export  const GetModuleList = () => useRecoilValue(moduleListAtom);



export  const SetModuleEdit = () => useSetRecoilState(moduleEditAtom);
export  const GetModuleEdit = () => useRecoilValue(moduleEditAtom);









